import React from 'react';
import { siteConfig } from '../../data/config';
import { Pending } from '../Pending';
export function SiteFooter() {
  return <footer className="border-t border-white/10 bg-deep px-5 py-6 text-center text-white/55" data-id="element-157" data-mp="1bdip632hbwrt">
      <div className="mx-auto max-w-[640px]" data-id="element-158" data-mp="1fhythzwg2w4x">
        <p className="text-[11px] font-semibold" data-id="element-159" data-mp="1kfrxcma9ze21">© {new Date().getFullYear()} DIESEL DIAGNOSTIC PRO™ — All rights reserved.</p>
        <p className="mt-2 text-[10.5px] leading-relaxed" data-id="element-160" data-mp="nqal1ogsetrd">
          DIESEL DIAGNOSTIC PRO™ is an educational reference for organizing diesel diagnostic work. It does not replace the manufacturer’s service
          information. Always confirm specifications, values and procedures in the documentation for the specific vehicle or engine, and follow
          applicable safety practices.
        </p>
        <ul className="mt-3 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[11px]" data-id="element-161" data-mp="42a5d57gfr2j">
          {siteConfig.legalLinks.map(l => <li key={l.label} data-id="element-162" data-mp="8yieo1yz0q1s">
              {l.href ? <a href={l.href} className="underline-offset-2 transition-colors duration-150 ease-out hover:text-gold hover:underline" data-id="element-163" data-mp="am27xzfh3wu7">
                  {l.label}
                </a> : <span className="inline-flex items-center gap-1" data-id="element-164" data-mp="1tifxhtosqic">
                  {l.label} <Pending label="Link" data-id="element-165" data-mp="3t1wbaa6vu6k7" />
                </span>}
            </li>)}
        </ul>
      </div>
    </footer>;
}